import Invoices from './Invoices';

export default Invoices;



// WEBPACK FOOTER //
// ./src/components/Query/Invoices/index.ts